import { createFileRoute } from '@tanstack/react-router'
import IsaChatPage from '@/pages/isa-chat/isa-chat-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/chat/',
)({
  component: function IsaChatIndexRoute() {
    const { dashboardId } = Route.useParams()
    return <IsaChatPage dashboardId={dashboardId} />
  },
})
